import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  people: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '12px',

    '&, & .scrollArea': {
      gap: '6px',

      '@media screen and (min-width: 1441px)': {
        gap: '8px',
      },
    },

    '& .users-line': {
      position: 'relative',
      overflow: 'hidden',

      '&, & .viboScrollbar': {
        margin: '-4px -4px -26px 0',
        padding: '4px 14px 26px 0px',

        '@media screen and (min-width: 1441px)': {
          margin: '-4px -4px -36px 0',
          padding: '4px 14px 36px 0px',
        },
      },

      '&.leftShadow': {
        '&::before': {
          left: 0,
          background: `
        linear-gradient(to right, var(--background-paper) 30%, rgba(255,255,255,0))`,
        },
      },

      '&.rightShadow': {
        '&::after': {
          right: 0,
          background: `
        linear-gradient(to left, var(--background-paper) 30%, rgba(255,255,255,0))`,
        },
      },

      '&::before, &::after': {
        content: "''",
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: 30,
        pointerEvents: 'none',
        zIndex: 10,
      },

      '& .viboScrollbar': {
        display: 'flex',
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
        whiteSpace: 'nowrap',
        gap: '6px',

        '&::-webkit-scrollbar': {
          height: '6px',
        },
      },
    },

    '@media screen and (min-width: 1441px)': {
      paddingBottom: '18px',
    },
  },
}));

export default useStyles;
